import { Component, OnInit } from '@angular/core';
import { UiStateService } from '../core/services/ui-state-service';
import { BackendService } from '../core/services/backend.service';
import { BaseComponent } from '../shared/base.component';
import { takeUntil } from 'rxjs/internal/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { DealerDto } from '../shared/api-models/models';
import { DataStateService } from '../core/services/data-state.service';
import { DEFAULT_DEALER_RESOURCE_VALUES } from './custom-dealer-resource-map';
import { DEFAULT_CROSS_PORTAL_LINK } from '../shared/constants';


const NO_PRODUCT = 'none';

@Component({
  selector: 'app-dealers',
  templateUrl: './dealers.component.html',
  styleUrls: ['./dealers.component.scss']
})
export class DealersComponent extends BaseComponent implements OnInit {
  //default values (no dealer guid);
  public seeLuvema: boolean = true;
  public seeIsowel: boolean = true;
  public seeCentor: boolean = false; //centor controlled by xml flag
  public seeHenderson: boolean = false; //henderson removal solicited by customer
  public currentDealerGuid: string | null = null;
  public crossPortalLink: string = DEFAULT_CROSS_PORTAL_LINK;
  public logoUrl: string = DEFAULT_DEALER_RESOURCE_VALUES.logoLink;

  constructor(private uiState: UiStateService,
    private backendService: BackendService,
    private router: Router,
    private dataStateService: DataStateService,
    private activatedRoute: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    const dealerGuid = this.activatedRoute.snapshot.paramMap.get('dealerGuid');
    this.uiState.setProductType(NO_PRODUCT);

    if (!dealerGuid) {
      this.dataStateService.setLandingPagePath(`/`);
      this.uiState.setCustomDealerResources(null);
      return;
    }

    this.dataStateService.setLandingPagePath(`/${dealerGuid}`);
    this.crossPortalLink = this.crossPortalLink + `/welkom/${dealerGuid}`;

    this.backendService.getDealers()
      .pipe(
        takeUntil(this.unsubscribe$))
      .subscribe(result => {
        let currentDealersGroup: DealerDto[] = result.filter(dealer => dealer.sleutel.toLowerCase() === dealerGuid.toLowerCase());
        if (!currentDealersGroup.length) {
          this.uiState.setCurrentDealersGroup(null);
          return;
        }

        let selectedDealer = currentDealersGroup[0];
        this.seeLuvema = !!selectedDealer.luvema;
        this.seeIsowel = !!selectedDealer.isowel;
        this.seeCentor = !!selectedDealer.centor;

        this.uiState.setCustomDealerResources(selectedDealer);
        this.uiState.setCurrentDealersGroup(currentDealersGroup);

        if (this.uiState.customDealerResources.logoLink) {
          this.logoUrl = this.uiState.customDealerResources.logoLink;
        }
      });
  }
}
